import { render, staticRenderFns } from "./RetailSales.vue?vue&type=template&id=64f9e38e&scoped=true&"
import script from "./RetailSales.vue?vue&type=script&lang=js&"
export * from "./RetailSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f9e38e",
  null
  
)

export default component.exports